<template>
  <v-card class="rounded-xl">
    <v-card-title class="text-center d-flex">
      <v-spacer></v-spacer>
      <h4 class="text-overline">
        Vendas do ano de {{ current_year }}
      </h4>
      <v-spacer></v-spacer>
      <v-btn icon small @click="getDashboard" v-show="show" :loading="loading">
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
      <v-btn icon small @click="show=!show" v-show="show">
        <v-icon small>mdi-cog</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-show="show">
      <bar-chart :dados="dados" height="300px"></bar-chart>
    </v-card-text>

    <v-card-text style="height:316px" v-show="!show">
      <v-row justify="center" align="center" dense>
        <v-col cols="6" align="center">
          <v-select
            v-model="current_year"
            label="Ano"
            dense
            filled
            :items="anos"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="6" align="center">
          <v-btn depressed color="primary" class="mr-2" @click="confirmar" :loading="loading">OK</v-btn>
          <v-btn text @click="show=!show" :disabled="loading">Cancelar</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from "@/components/graficos/BarChart";
import { range, mesExtenso } from "@/app/helpers/utils";

export default {
  name: 'GraficoVendasAnual',

  components: {
    BarChart
  },

  data: () => ({
    dados: {},
    loading: false,
    refreshing: false,
    show: true,
    current_year: new Date().getFullYear(),
    current_month: new Date().getMonth() + 1,
  }),

  computed: {
    anos() {
      return range(new Date().getFullYear(), 2018);
    },

    mesExtenso() {
      return mesExtenso(this.current_month);
    }
  },

  async created () {
    this.loading = false;
    await this.getDashboard();
  },

  methods: {

    async getDashboard() {
      try {
        this.loading = true;

        const response = await this.$axios.get('/dashboard/grafico-vendas-ano', {
          params: {
            ano: this.current_year
          }
        });
        this.dados = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async confirmar() {
      await this.getDashboard();
      this.show = true;
    }
  },
};
</script>

<style>
  .sublinhado {
    text-decoration: underline;
  }
</style>